<template lang="pug">
  div.module-sign-in
    div.module-sign-in-content.f.fh
      div
        div.wrap-logo.f.fc.mb40
          div.logo
            v-img(src="/img/logo.svg")
        div.f.fc
          ItemSignInWithEmail(@toggleShowSocialSignIn="showSocialSignIn = !showSocialSignIn")
        div(v-if="showSocialSignIn").mt30
          span.block.fz12.text-center By continuing, you are indicating that you accept our
          span.block.fz12.text-center #[a(:href="privacyPolicy" target="blank").fz12 Terms of Service] and #[a(:href="serviceTerms" target="blank").fz12 Privacy Policy]
        div.switch-sign-in-up.f.fc.mt80
          span(@click="onSwitch").cursor-pointer {{($route.name == 'sign-in') ? 'Sign up?' : 'Sign in?'}}
</template>

<style scoped lang="scss">
@import "@/scss/_variables.scss";

.module-sign-in {
  position: relative;
  .module-sign-in-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $base_max_width_px;
    min-height: 100vh;
    .wrap-logo {
      .logo {
        width: 200px;
      }
    }
    span {
      a {
        color: $secondary_text_color;
      }
    }
  }
  .switch-sign-in-up {
    // position: absolute;
    // bottom: 80px;
    // width: 100%;
    span {
      color: $active_color;
    }
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('auth')
import ItemSignInWithEmail from '@/components/item/ItemSignInWithEmail'

export default {
  components: {
    ItemSignInWithEmail
  },
  data () {
    return {
      privacyPolicy: '/privacy_policy.pdf',
      serviceTerms: '/terms_terms.pdf',
      showSocialSignIn: true
    }
  },
  computed: {
    ...mapState(['isLoggedIn'])
  },
  watch: {
    showSocialSignIn () {
      console.log('this.showSocialSignIn', this.showSocialSignIn)
    }
  },
  methods: {
    onSwitch () {
      const to = (this.$route.name == 'sign-in') ? 'sign-up' : 'sign-in'
      
      const pathWithParam = (this.$route.params.redirectPath) ? 
        `/${to}/${encodeURIComponent(this.$route.params.redirectPath)}` : `/${to}`
      this.$router.push(pathWithParam)
    }
  }
}
</script>